module.exports = __webpack_public_path__ + "static/media/icon_46_group.24790ca5.svg";